import * as SentryReact from '@sentry/react';
import { useMutation } from '@tanstack/react-query';

import { stripeService } from '@/services/stripe';
import { StripeV2PaymentRequest } from '@/services/stripe/dto';

export const useStripeV2Payment = () => {
  return useMutation({
    mutationFn: (params: StripeV2PaymentRequest) => {
      return stripeService.createV2Payment(params);
    },
    mutationKey: ['stripeV2Payment'],
    onError: (error: unknown) => {
      SentryReact.captureException(error);
    },
  });
};
